import { Department } from '../types/department';
import { DepartmentWithMemberCountResponse } from '../types/response/department-with-member-count-response';

/**
 * Maps API response DTO to domain model
 */
export const mapDepartmentFromDTO = (dto: DepartmentWithMemberCountResponse): Department => ({
  id: dto.id,
  name: dto.name,
  memberCount: dto.memberCount,
});

/**
 * Maps array of API response DTOs to domain models
 */
export const mapDepartmentsFromDTO = (dtos: DepartmentWithMemberCountResponse[]): Department[] =>
  dtos.map(mapDepartmentFromDTO);
